








































import Vue from 'vue';
import Component from 'vue-class-component';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import PageContainer from '@/general/component/PageContainer.vue';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';
import DataLoggerRouter from '@/context/data_logger/router/DataLoggerRouter';
import { DataLoggerFilter } from '@/context/data_logger/model/DataLoggerFilter';
import TextInput from '@/general/component/form/input/TextInput.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import { Api } from '@/common/api/Api';
import ColoredBooleanField from "@/general/component/ColoredBooleanField.vue";

@Component({
  components: {
    ColoredBooleanField,
    CustomerAutocomplete,
    PageContainer,
    FacilityAutocomplete,
    ModelAutocomplete,
    TextInput
  }
})
export default class DataLoggerListContainer extends Vue {
  router: DataLoggerRouter = new DataLoggerRouter();
  deleteApi: Api = dataLoggerApi;
  filter: DataLoggerFilter = new DataLoggerFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Identyfikator",
      value: "identifier",
      align: "left"
    },
    {
      text: "Obiekt",
      value: "storeNumber",
      align: "left"
    },
    {
      text: "Klient",
      value: "clientName",
      align: "left"
    },
    {
      text: "Online",
      value: "online",
      align: "left"
    },
    {
      text: "Active",
      value: "active",
      align: "left"
    },
    {
      text: "Kraj",
      value: "country",
      align: "left"
    }
  ];
  api: Api = dataLoggerApi;
}
